<div
  #tutorialsModal
  class="fade modal-lg modal"
  id="tutorialsModal"
  tabindex="-1"
  aria-labelledby="tutorialFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="tutorialFormModalLabel">
          Listado de tutoriales
        </h1>

        <button class="btn-custom ms-3" (click)="openCompleteTutorialsForm()">
          Crear Tutorial
        </button>

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="d-flex justify-content-center" *ngIf="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div *ngIf="!loading">
          <div class="" *ngFor="let section of sections">
            <span class="fw-bold fs-5">{{ section.name | uppercase }}</span>

            <div
              class="tutorial-card my-1 d-flex justify-content-between"
              *ngFor="let tutorial of section.tutorials"
            >
              <div class="d-flex flex-column">
                <span class="fw-semibold fs-6" style="font-size: 16px">{{
                  tutorial.name
                }}</span>

                <div class="d-flex align-items-center">
                  <span class="fw-light me-2" style="font-size: 12px">{{
                    tutorial.formatSpanish
                  }}</span>
                  |
                  <span class="fw-light ms-2" style="font-size: 12px">{{
                    tutorial.allowedUserTypeSpanish
                  }}</span>
                </div>
              </div>

              <div class="d-flex align-items-center">
                <!-- <i
                class="bi bi-pencil-square me-2"
                style="font-size: 20px; cursor: pointer"
                (click)="selectTutorial(tutorial)"
              ></i> -->
                <i
                  class="bi bi-trash me-2"
                  (click)="deleteTutorial(section, tutorial)"
                  style="font-size: 24px; color: #dc3545; cursor: pointer"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
